<mat-toolbar class="footer">
  <div>
    <span>Copyright &copy; VVCR {{currentYear}}</span>
  </div>
</mat-toolbar>
